module.exports = __webpack_public_path__ + "img/bauges2021-1.aeddb6e9.jpg";